import PropTypes from 'prop-types';
import Portfolio from '../common/Portfolio/Portfolio';
import styles from './ProjectItem.module.scss';
import { VisibilityOutlined, CodeOutlined } from '@mui/icons-material';
import AnimatedWrapper from '../common/AnimatedWrapper/AnimatedWrapper';

const ProjectItem = ({ title, description, galleryPath, demoLink, codeLink }) => {
  return (
    <div className={styles.projectItem}>
      <div className={styles.projectItem__imageContainer}>
        <AnimatedWrapper>
          <Portfolio folderPath={galleryPath} />
        </AnimatedWrapper>
      </div>
      <div className={styles.projectItem__content}>
        <AnimatedWrapper>
          <h2 className={styles.projectItem__title}>{title}</h2>
        </AnimatedWrapper>
        <AnimatedWrapper>
          <p className={styles.projectItem__description}>{description}</p>
        </AnimatedWrapper>
        <div className={styles.projectItem__actions}>
          {demoLink && (
            <AnimatedWrapper>
              <a href={demoLink} target="_blank" rel="noopener noreferrer" className={styles.projectItem__button}>
                <VisibilityOutlined sx={{ marginRight: '8px' }} />
                <span>Zobacz stronę</span>
              </a>
            </AnimatedWrapper>
          )}
          {codeLink && (
            <AnimatedWrapper>
              <a href={codeLink} target="_blank" rel="noopener noreferrer" className={`${styles.projectItem__button} ${styles.projectItem__button_secondary}`}>
                <CodeOutlined sx={{ marginRight: '8px' }} />
                <span>Zobacz kod</span>
              </a>
            </AnimatedWrapper>
          )}
        </div>
      </div>
    </div>
  );
};

ProjectItem.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  galleryPath: PropTypes.string.isRequired,
  demoLink: PropTypes.string,
  codeLink: PropTypes.string
};

export default ProjectItem; 